export default (v) => {
    if (!v) {
        return;
    }
    return v.substring(0, 2) + '-' + v.substring(2, 10) + '-' + v.substring(-1, 1);
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/cuit.js